import { render, staticRenderFns } from "./ModelHouseIndex.vue?vue&type=template&id=5695cd94&"
import script from "./ModelHouseIndex.vue?vue&type=script&lang=js&"
export * from "./ModelHouseIndex.vue?vue&type=script&lang=js&"
import style0 from "./ModelHouseIndex.vue?vue&type=style&index=0&id=5695cd94&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports